export default __webpack_public_path__ + "static/media/MinerMk3.256.cb1f4d12.png";